import Header from './Header';
import { AddToCartURL, FilterList, image_url, Post, ProductsURL,IngredientPrr } from '../utils/api';
import { useEffect, useState } from 'react';
import Button from '../component/Button';
import Filter from './Filter';
import { useNavigate,Link, useParams } from 'react-router-dom';
import { wrapComponent } from 'react-snackbar-alert';
import { useSelector } from 'react-redux';
import CartModal from '../component/cartModal';

const IngredientProducts = ({createSnackbar}) => {
    const [List,setList] = useState([]);
    const [faq,setfaq] = useState([]);
    const params = useParams();
    const {cartItems,userinfo} = useSelector((state)=>state);

    const navigate = useNavigate();
    
    useEffect(()=>{
        fetchItemList();
    },[params?.searchKey]);

    const fetchItemList = (data) =>{
        global.Loader(true)
        let body = (data)?data:{};
        if(params?.searchKey) {
            body.searchKey = params?.searchKey;
        }
        
        let config = {
             body:{product_id:params?.id},
            url:IngredientPrr,
        }
        
        Post(config).then((res)=>{
            global.Loader(false)
            console.log(res);
            if(res.status == true) {
                setfaq(res?.faq)
                setList(res?.products)
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err?.response?.data);
        })
    }

    const showSnack = (msg='',type='error') =>{
        createSnackbar({
            message: msg,
            theme: type,
        });
    }
    const [refres,setrefres] = useState(false);

    const addToCart = ({qnty=1,id,varient_id}) =>{
        if(userinfo?.token){
            if(varient_id) {
                global.Loader(true)
                let config = {
                    body:{
                        product_id:id,
                        variant_id:varient_id,
                        quantity:qnty,
                    },
                    url:AddToCartURL,
                }
                Post(config).then((res)=>{
                    global.Loader(false)
                    if(res.status == true) {
                        setrefres(!refres)
                        showSnack(res?.msg,'success')
                        let index = cartItems?.findIndex((v)=>v.product_id == id);
                        if(index == -1) {
                            global.dispatch({
                                type:'CARTITEMS',
                                payload: [...cartItems,{product_id:id}]
                            })
                        }
                        
                    }
                }).catch((err)=>{
                    global.Loader(false)
                    console.log(err?.response?.data);
                })
            } else {
                showSnack('Please Select Varient')
            }
        } else {
            showSnack('Please Login')
            navigate('/login')
        }
        
    }
   
    const changeQnty = (qnty,itemId) =>{
        let list = [...List];
        const index = list?.findIndex(v=>v.id == itemId);
        
        if(index != -1) {
            list[index]['qnty'] = qnty;
        }

        setList(list);
    }

    const selectVarient = ({id,product_weight,product_id}) =>{
        let list = [...List];
        const index = list?.findIndex(v=>v.id == product_id);
        if(index != -1) {
            list[index]['varient_id'] = id;
            list[index]['product_weight'] = product_weight;
        }

        setList(list);
    }
    const truncate = (value,i) =>{
        return value;
        if(value) {
            return `${value.substr(0,i)}...`;
        } else {
            return '';
        }
    }
    
const getRating= (value) =>{
    let Array =[];
    let lasti = 1;
    for(let i = 1; i < 6; i++) {
        if(value >= i) {
            Array.push(1);
        } else {
            Array.push(0);
        }
    }
    return Array;
  }
    return (
        <div className="best">
            <Header  cartClick={()=>{
        setrefres(!refres)
      }}  />
    <div className="mizuki1">
        <span className="ipsum"><i className="fa-solid fa-left-long"></i></span>
        <h1>Ingradient</h1>
        <span className="ipsum1"><i className="fa fa-search" aria-hidden="true"></i></span>
    </div>

    <section>
        <div className="container-fluid">
            <div className="row">
                <Filter onFilter={(data)=>{
                    fetchItemList(data)
                }} />
                <div className="col-md-9" style={{marginTop:'50px',marginBottom:'50px'}}>
                    <div className="homeshop">
                        <div className="homelink">
                            <ul>
                                <li onClick={()=>{
                                    navigate('/home')
                                }}>Home</li> <i className="fa-solid fa-chevron-right" style={{'marginRight':'5px'}}></i>
                                <li onClick={()=>{
                                    navigate('/shoppage')
                                }}><a href="#">shop</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="coupons">
                        {/* <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">All</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Products</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Product Bundles</button>
                            </li>
                        </ul> */}
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="pills-home" role="tabpanel"
                                aria-labelledby="pills-home-tab">
                                <div className="neel">
                                    {(List?.length == 0)&&
                                    <div style={{
                                        'fontSize': '30px',
                                        'fontWeight': 'bold',
                                        'marginTop': '100px',
                                        'display': 'flex',
                                        'justifyContent': 'center',
                                        'alignItems': 'center',
                                    }}>
                                        <span>No Products Found!</span>
                                    </div>}
                                    {List?.map((value)=>(
                                        <div className="gagan">
                                            <div className="row">
                                                <div className="col-md-4" onClick={()=>navigate(`/shop/${value.id}`)} >
                                                    <div className="active_botal">
                                                        <img src={`${image_url}${value?.image}`} alt="" style={{height:'200px',width:'200px'}}/>
                                                    </div>
                                                    <div className="active_botal1">
                                                        {/* <img src="/images/latte mix1.png" alt=""/> */}
                                                    </div>
                                                </div>
                                                <div className="col-md-4" onClick={()=>navigate(`/shop/${value.id}`)} >
                                                    <div className="quality5">
                                                        <div className="onerymix">
                                                            <h4 style={{fontSize:'20px'}}>{truncate(value.title,17)}</h4>
                                                            {getRating(value.avg_rating)?.map((v,i)=>(
                                                                (v==1)?<i className="fa-solid fa-star"></i>:<i className="fa-regular fa-star"></i>
                                                            ))}
                                                            {/* <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-solid fa-star"></i>
                                                            <i className="fa-regular fa-star"></i> */}
                                                             {' '}{value.no_of_review}
                                                            <p style={{
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden', 
                                                                maxHeight: '180px', 
                                                                whiteSpace: 'nowrap',
                                                            }} dangerouslySetInnerHTML={{__html: value?.description}}></p>
                                                            {/* <div className="qualitymix">
                                                                <div className="dropdown">
                                                                    <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        <p>200g x 1 Pkt <i className="fa-solid fa-angle-down"></i><br/> <span>Orange mix</span></p>
                                                                    </button>
                                                                    <h2>₹{value?.price}</h2>
                                                                    <ul className="dropdown-menu" style={{}} aria-labelledby="dropdownMenuButton2">
                                                                        {value?.item_variations?.map((v,i)=>(
                                                                            <li><a className="dropdown-item something" href="#">{v?.product_weight} x 1 Pkt {value?.title} </a></li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                        <div className="stati">
                                                            <p>Contains healing enzymes, which repair dead skin<br/> cells and make skin glow.</p>
                                                        </div>
                                                        {/* <div className="iconpad1">
                                                            {value?.product_benefit?.map((v,i)=>(
                                                                <p><img src={`${image_url}${v?.icon}`} style={{height:'30px',width:'30px',marginRight:'10px'}} /> {v?.point}</p>
                                                            ))}
                                                        </div> */}
                                                        <div className="quality3button">
                                                            <Button title={`Add to cart (₹${value?.price})`} />
                                                            {/* <button>Add to cart (₹599)</button> */}
                                                            <p>Free 7-10 days delivery across India</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="quality">
                                                        <div className="quality1">
                                                            <div className="dropdown">
                                                                <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    {(value?.varient_id)?
                                                                        <p>{value?.product_weight} <i className="fa-solid fa-angle-down"></i></p>
                                                                    :
                                                                        <p>Select Varient <i className="fa-solid fa-angle-down"></i><br/> </p>
                                                                    }
                                                                </button>
                                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton2" style={{
                                                                    maxWidth: '197px',
                                                                    backgroundColor: 'transparent',
                                                                    border: '0px',
                                                                }}>
                                                                    {value?.item_variations?.map((v,i)=>{
                                                                        if(value?.item_variations?.length == 1) {
                                                                            return <li onClick={()=>{
                                                                                selectVarient(v,value?.id)
                                                                            }}><a className="dropdown-item something1" style={{borderRadius:'25px'}} ><p>{v?.product_weight}</p></a></li>;
                                                                        }
                                                                        else if(i == 0) {
                                                                            return <li onClick={()=>{
                                                                                selectVarient(v,value?.id)
                                                                            }}><a className="dropdown-item active something" ><p>{v?.product_weight}</p></a></li>;
                                                                        } else if(i == value?.item_variations?.length - 1) {
                                                                            return <li onClick={()=>{
                                                                                selectVarient(v,value?.id)
                                                                            }}><a className="dropdown-item something2" ><p>{v?.product_weight}</p></a></li>;
                                                                        } else {
                                                                            return <li onClick={()=>{
                                                                                selectVarient(v,value?.id)
                                                                            }}><a className="dropdown-item something1" ><p>{v?.product_weight}</p></a></li>;
                                                                        }
                                                                    })}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div className="quality2">
                                                            <p>Free 7-10 days delivery across India</p>
                                                        </div>
                                                        <div className="quality4">
                                                            <div className="quality3">
                                                                <h2>₹{value.price} {/*<s>800</s>*/} 
                                                                    <select onChange={({target})=>{
                                                                        changeQnty(target?.value,value?.id);
                                                                    }} value={(value?.qnty)?value?.qnty : 1} style={{
                                                                        width: "56px",
                                                                        borderRadius: "15px",
                                                                        fontSize: "16px",
                                                                        paddingLeft: "10px",
                                                                        paddingRight: "10px",
                                                                        backgroundColor: "white",
                                                                        border: "0px",
                                                                    }}>
                                                                        <option><span>1 <i className="fa-solid fa-angle-down"></i></span></option>
                                                                        <option><span>2 <i className="fa-solid fa-angle-down"></i></span></option>
                                                                        <option><span>3 <i className="fa-solid fa-angle-down"></i></span></option>
                                                                        <option><span>4 <i className="fa-solid fa-angle-down"></i></span></option>
                                                                        <option><span>5 <i className="fa-solid fa-angle-down"></i></span></option>
                                                                        <option><span>6 <i className="fa-solid fa-angle-down"></i></span></option>
                                                                        <option><span>7 <i className="fa-solid fa-angle-down"></i></span></option>
                                                                        <option><span>8 <i className="fa-solid fa-angle-down"></i></span></option>
                                                                        <option><span>9 <i className="fa-solid fa-angle-down"></i></span></option>
                                                                        <option><span>10 <i className="fa-solid fa-angle-down"></i></span></option>
                                                                    </select>
                                                                </h2>
                                                            </div>
                                                            <div className="quality4button">
                                                                <Button onClick={()=>{
                                                                    addToCart(value)
                                                                }} style={{width:'100%',fontSize:13}} backgroundColor={'#219653'} title={`Add to cart (₹${(value?.price * parseInt((value?.qnty)?value?.qnty:1))})`} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">2</div>
                            <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">3</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="back">
                <ul className="pager">
                    {/* <li><a href="#" className="back1"><i className="fa-solid fa-angle-left"></i> Back</a></li>
                    <li><a href="#" className="back2">1</a></li>
                    <li><a href="#" className="back3">2</a></li>
                    <li><a href="#" className="back4">3</a></li>
                    <li><a href="#" className="next">Next <i className="fa-solid fa-angle-right"></i></a></li> */}
                </ul>
            </div>
        </div>
    </section>
    <CartModal refres={refres} show={true} />

    <div className="faqs" style={{display:'flex',flexDirection:'column'}}>
        <h2>FAQs</h2>
        <div class="tab-content" id="myTabContent" style={{alignSelf:'center'}}>
            <div class="tab-pane fade active show" id="contact" role="tabpanel" aria-labelledby="contact-tab">
            {faq?.map((v,i)=>(
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade active show" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseThree${i}`} aria-expanded="false" aria-controls={`collapseThree${i}`}>{v.title}</button>
                                </h2>
                                <div id={`collapseThree${i}`} class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                <div class="accordion-body">{v.description}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            </div>
        </div>
    </div>
        </div>
    );
};
  
export default wrapComponent(IngredientProducts);